import { render, staticRenderFns } from "./OrdersAppRightToAppealPg.vue?vue&type=template&id=11f2f970&scoped=true"
import script from "./OrdersAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./OrdersAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2f970",
  null
  
)

export default component.exports